<script setup lang="ts">
import { Color } from '@previo/codebooks'
import PBtn from '../../btn/PBtn.vue'
import { PBtnType } from '../../btn/types'

type Props = {
  text?: null | string
  endIcon?: null | string
}

type Emits = {
  (e: 'click', evt: Event): void
}

withDefaults(defineProps<Props>(), {})
const emits = defineEmits<Emits>()
</script>

<template>
  <p-btn
    :type="PBtnType.SECONDARY"
    :color="Color.POSITIVE"
    :text="text"
    :icon-end="endIcon"
    grow
    cy="create"
    @click="(args) => emits('click', args)"
  />
</template>
